/* Copyright 2023 (Unpublished) Verto Inc. */

// Angular
import { Component, OnInit } from '@angular/core';
import { Router, Data, ActivatedRoute, ActivationStart } from '@angular/router';

// Library
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

// Services
import { CurrentUserService } from '../../services/root-services/current-user.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: [
    './breadcrumb.component.scss',
    '../../logs/executions/executions.component.scss',
  ],
})
export class BreadcrumbComponent implements OnInit {
  faChevronRight = faChevronRight;

  routerData: Data;
  breadcrumbList: Array<{ label: string; url?: string; last?: boolean }>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
        this.routerData = event.snapshot.data;
        let breadcrumb = this.routerData.breadcrumb;

        this.breadcrumbList = [];
        switch (breadcrumb) {
          case 'New Robot':
            this.breadcrumbList.push({ label: breadcrumb, last: true });
            break;

          case 'Edit Robot':
            this.breadcrumbList.push({ label: breadcrumb, last: true });
            break;

          case 'Robot':
            this.breadcrumbList.push({ label: breadcrumb, last: true });
            break;

          case 'Executions':
            this.breadcrumbList.push({ label: breadcrumb, last: true });
            break;

          case 'Execution':
            this.breadcrumbList.push({
              label: 'Executions',
              url: '/executions',
            });
            this.breadcrumbList.push({ label: 'Execution', last: true });
            break;

          case 'Packs':
            this.breadcrumbList.push({
              label: breadcrumb,
              url: '/packs',
              last: true,
            });
            break;

          case 'Credentials':
            this.breadcrumbList.push({ label: 'Credentials', last: true });
            break;

          case 'Users':
            this.breadcrumbList.push({ label: 'Users', last: true });
            break;

          case 'Labels':
            this.breadcrumbList.push({ label: 'Labels', last: true });
            break;

          case 'Campaigns':
            this.breadcrumbList.push({ label: 'Campaigns', last: true });
            break;

          case 'Templates':
            this.breadcrumbList.push({ label: 'Templates', last: true });
            break;

          case 'Visualizer':
            this.breadcrumbList.push({ label: 'Visualizer', last: true });
            break;

          default:
            this.breadcrumbList = [{ label: 'Robots', last: true }];
        }
      }
    });
  }
}
